<template>
    <div class="omni-dropdown-card">
        <div v-for="(item, key) in cardItems" :key="key" class="card-item">
            <a v-if="item.openInCurrentTab" :href="parseLink(item.value)">
                {{ parseLabel(item.label) }}
            </a>
            <a v-else :href="parseLink(item.value)" target="_blank">
                {{ parseLabel(item.label) }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "OmniDropdownCard",
    props: {
        cardItems: {
            type: Array,
            required: true,
        },
        cardItemVariables: {
            type: Object,
            required: false,
            default: {}, // avoids errors
        },
    },
    methods: {
        parseLabel(label) {
            return this.parseTemplate(label, this.cardItemVariables);
        },
        parseLink(link) {
            return this.parseTemplate(link, this.cardItemVariables);
        },
        parseTemplate(template, variables) {
            return Object.keys(variables).reduce((str, varName) => {
                return str.replace(`{${varName}}`, variables[varName]);
            }, template);
        },
    },
};
</script>

<style lang="scss">
.omni-dropdown-card {
    display: inline-flex;
    flex-direction: column;
    font-family: "Arial", sans-serif;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease-in-out;
    border-radius: 6px;
    overflow: hidden;
    background-color: #f4f7fa;
    margin: 10px;
    border: 1px solid #e1e1e1;
    position: absolute;
    left: -0.25rem;
    top: -0.25rem;
    min-width: 20rem;
    z-index: 10;

    .card-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        &:last-child {
            border-bottom: none;
        }

        a {
            display: block;
            text-decoration: none;
            color: #333333;
            padding: 12px 16px;
            border-bottom: 1px solid #e1e1e1;
            transition: background-color 0.3s ease;

            &:hover {
                background-color: darken(#f4f7fa, 5%);
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
